import { Injectable } from '@angular/core';
import { getCampaignsModel, newCampaignModel, CampaignModel, DashboardCampaigns, CampaignTrackingModel } from '../models/campaign.model';
import { MainService } from './main.service';
import jwt_decode from 'jwt-decode';
import { defer, filter, from, map, mergeMap, Observable, retryWhen, switchMap, tap, timer } from 'rxjs';
import { newStrategyModel } from '../models/strategy.model';
import { UsersService } from './users.service';
import { environment } from 'src/environments/environment';
import { HttpBackend, HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';

export interface MultipartUploadState {
    progress: number;
    confirming: boolean;
    complete: boolean;
    delayed?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CampaignsService {

  private storageHttp: HttpClient;

  constructor(
    private main: MainService,
    private usrService : UsersService,
    backend: HttpBackend
  ) {
    // La carga al almacenamiento no debe enviar el token de la aplicación.
    this.storageHttp = new HttpClient(backend);
  }
    areaName : string = '/campaigns'
    distribution : string = "/distribution"
//Miscellaneous area
    getUsrRol():  number{
        return this.usrService.getUser().id_rol;
    }

    hasPermissions(key : string, buho : boolean|any, client : boolean|any):  boolean{
        return this.usrService.getUser().id_rol == environment.role_admin_id || (buho==null&&this.isBuhoUsr()) || (client==null&&this.isClientUsr()) || (((buho?this.isBuhoUsr():false) || (client?this.isClientUsr():false)) && (this.usrService.getUser().permissions.includes(key)));
    }

    isBuhoUsr(): boolean{
        return  this.usrService.getUser().id_rol == environment.role_buho ||  this.usrService.getUser().id_rol == environment.role_admin_id;
    }
    isClientUsr(): boolean{
        return  this.usrService.getUser().id_rol == environment.role_client;
    }


//Campaigns area
    getCampaigns(){
        var get : getCampaignsModel =  new getCampaignsModel()
        get.active = 1;
        return this.main.postRequest(get, this.areaName + "/show").pipe(
        map((x:any)=>{
                let objReturn = new DashboardCampaigns();
                if(x.message == 'Success'){
                    x.data.forEach((e:any) => {
                        let tmpdate = new Date(e.deadline);
                        tmpdate.setTime(tmpdate.getTime() + 6 * 60 * 60 * 1000);
                        let tmpYear = tmpdate.getFullYear();
                        if(tmpYear != tmpdate.getFullYear()){
                            if(!objReturn.pastyears[tmpYear]){
                                objReturn.pastyears[tmpYear] =  new Array<any>()
                            }
                            objReturn.pastyears[tmpYear].push(e);
                        }else{
                           //if active then {this code } else push inactive   
                           if(new Date(Date.now()) < tmpdate || e.locked == 0){
                               objReturn.progress.push(e)
                           }else{
                               objReturn.finished.push(e)
                           }  
                           objReturn.all.push(e);
                        }
                    });
                }
                return objReturn;
        }));
    }

    getCampaignsByCompany(compId : number){
        var get : getCampaignsModel =  new getCampaignsModel()
        get.active = 1;
        return this.main.postRequest(get, this.areaName + "/filterbycompany/" + compId).pipe(
        map((x:any)=>{
                let objReturn = new DashboardCampaigns();
                if(x.message == 'Success'){
                    x.data.forEach((e:any) => {
                        let tmpdate = new Date(e.deadline);
                        tmpdate.setTime(tmpdate.getTime() + 6 * 60 * 60 * 1000);
                        let tmpYear = tmpdate.getFullYear();
                        if(tmpYear != tmpdate.getFullYear()){
                            if(!objReturn.pastyears[tmpYear]){
                                objReturn.pastyears[tmpYear] =  new Array<any>()
                            }
                            objReturn.pastyears[tmpYear].push(e);
                        }else{
                           //if active then {this code } else push inactive   
                           if(new Date(Date.now()) < tmpdate || e.locked == 0){
                               objReturn.progress.push(e)
                           }else{
                               objReturn.finished.push(e)
                           }  
                           objReturn.all.push(e);
                        }
                    });
                }
                return objReturn;
        }));
    }

    getCampaignsQRByCompany(compId : number){
        var get : getCampaignsModel =  new getCampaignsModel()
        get.active = 1;
        console.log("load by")
        return this.main.postRequest(get, this.areaName + "/filterqrbycompany/" + compId).pipe(
        map((x:any)=>{
                let objReturn = new DashboardCampaigns();
                if(x.message == 'Success'){
                    x.data.forEach((e:any) => {
                        let tmpdate = new Date(e.deadline);
                        tmpdate.setTime(tmpdate.getTime() + 6 * 60 * 60 * 1000);
                        let tmpYear = tmpdate.getFullYear();
                        if(tmpYear != tmpdate.getFullYear()){
                            if(!objReturn.pastyears[tmpYear]){
                                objReturn.pastyears[tmpYear] =  new Array<any>()
                            }
                            objReturn.pastyears[tmpYear].push(e);
                        }else{
                           //if active then {this code } else push inactive   
                           if(new Date(Date.now()) < tmpdate || e.locked == 0){
                               objReturn.progress.push(e)
                           }else{
                               objReturn.finished.push(e)
                           }  
                           objReturn.all.push(e);
                        }
                    });
                }
                return objReturn;
        }));
    }

    newCampaign(newCampain : newCampaignModel){
        return this.main.postRequest(newCampain, this.areaName +"/create");
    }

    editCampaign(newCampain : newCampaignModel){
        return this.main.postRequest(newCampain, this.areaName +"/edit");
    }

    deleteCampaign(campid : number){
        return this.main.postRequest({ id: campid }, "/campaigns/delete/");
    }

    getCampaign(campid : number){
        return this.main.getRequest("/campaigns/show/" + campid);
    }

    getCampaignChangelog(campid : number){
        return this.main.getRequest("/campaigns/changelog/" + campid);
    }

    newCampaignMessage(newMessage : any){
        return this.main.postRequest(newMessage, "/campaigns/message/");
    }

    unlockCampaign(campid : number){
        return this.main.postRequest({id_camp: campid}, "/campaigns/unlock/");
    }

    lockCampaign(campid : number){
        return this.main.postRequest({id_camp: campid}, "/campaigns/lock/");
    }
//Strategies area
    saveStrategy(newStrategy : newStrategyModel, isEdit : boolean){
        var createEdit = ""
        isEdit ? createEdit  = "edit" : createEdit  = "create";
        return this.main.postRequest(newStrategy, "/strategies/" + createEdit);
    }

    getCampaignStrategies(campid : number){
       return this.main.postRequest({ id_camp : campid }, "/strategies/show");
    }

    updateStrategyStatus(strategy: any){
        return this.main.postRequest(strategy, "/strategies/status");
    }

    getStrategiesChangelog(strid : number){
        return this.main.getRequest("/strategies/changelog/" + strid);
    }

    newStrategyMessage(newMessage : any){
        return this.main.postRequest(newMessage, "/strategies/message/");
    }
    
    getStrategyArts(strid : number){
        return this.main.getRequest("/strategies/files/art/" + strid);
    }

    getStrategyOdts(strid : number){
        return this.main.getRequest("/strategies/files/odt/" + strid);
    }

    deleteStrategy(strid : number){
        return this.main.postRequest({ id: strid }, "/strategies/delete/");
    }

    uploadArtFile(form : FormData){
        return this.main.postRequestFormData(form, "/strategies/files/art/");
    }

//Subida de artes de distribución con URLs prefirmadas
    confirmArtUpload(uploadId : string){
        return this.main.postRequest({ usePresignedUpload: true, uploadId }, "/strategies/files/art/complete");
    }

    initArtUpload(data : any){
        return this.main.postRequest(data, "/strategies/files/art/init");
    }

    uploadDistributionArtFile(file : File, metadata : any, usePresignedUpload : boolean): Observable<MultipartUploadState>{
        if (!usePresignedUpload) {
            const form = new FormData();
            Object.keys(metadata).forEach(key => form.set(key, String(metadata[key])));
            form.set('usePresignedUpload', 'false');
            form.set('blob', file);
            return this.uploadArtFile(form).pipe(
                map((result : any) => {
                    if (result.message !== 'Success') {
                        throw new Error('No se pudo registrar el archivo');
                    }
                    return { progress: 100, confirming: false, complete: true };
                })
            );
        }

        return this.uploadMultipartFile(file, metadata,
            data => this.initArtUpload(data),
            uploadId => this.confirmArtUpload(uploadId));
    }
//Fin de subida de artes con URLs prefirmadas

//Transferencia multipart 
    uploadFileToStorage(file : Blob, signed : any){
        return this.storageHttp.put(signed.url, file, {
            headers: signed.headers,
            reportProgress: true,
            observe: 'events',
            responseType: 'text'
        });
    }

    getMultipartPartUrl(uploadId : string, partNumber : number){
        return this.main.postRequest({ uploadId, partNumber }, "/uploads/multipart/part-url");
    }

    abortMultipartUpload(uploadId : string){
        return this.main.postRequest({ uploadId }, "/uploads/multipart/abort");
    }

    uploadMultipartFile(file : File, metadata : any,
        initUpload : (data : any) => Observable<any>,
        completeUpload : (uploadId : string) => Observable<any>): Observable<MultipartUploadState>{
        const data = {
            ...metadata,
            usePresignedUpload: true,
            fileName: file.name,
            contentType: file.type || 'application/octet-stream',
            size: file.size
        };
        return new Observable<MultipartUploadState>(subscriber => {
            let uploadId : string;
            let finished = false;
            let confirming = false;
            const loaded = new Map<number, number>();
            const waiting = new Set<number>();
            const reportProgress = () => subscriber.next({
                progress: Math.min(100, Math.round(100 * Array.from(loaded.values()).reduce((sum, bytes) => sum + bytes, 0) / file.size)),
                confirming: confirming,
                complete: false,
                delayed: waiting.size > 0
            });
            //Reintentar solo fallos temporales; cada parte obtiene una firma nueva al repetir.
            const retryUpload = (partNumber : number, renewSignature = false) => retryWhen(errors => errors.pipe(
                mergeMap((error, attempt) => {
                    const temporary = error.status === 0 || error.status === 408 || error.status === 429 ||
                        error.status >= 500 || (renewSignature && error.status === 403);
                    if (!temporary || attempt >= 3) {
                        throw error;
                    }
                    waiting.add(partNumber);
                    if (partNumber > 0) {
                        loaded.set(partNumber, 0);
                    }
                    reportProgress();
                    return timer(2000 * 2 ** attempt);
                })
            ));

            const task = initUpload(data).pipe(
                switchMap((session : any) => {
                    uploadId = session.uploadId;
                    const parts = Array.from({ length: session.totalParts }, (_, index) => index + 1);
                    return from(parts).pipe(
                        mergeMap(partNumber => {
                            const start = (partNumber - 1) * session.partSize;
                            const part = file.slice(start, Math.min(file.size, start + session.partSize), file.type);
                            return defer(() => this.getMultipartPartUrl(uploadId, partNumber).pipe(
                                switchMap((signed : any) => this.uploadFileToStorage(part, signed)),
                                tap((event : HttpEvent<string>) => {
                                    if (event.type === HttpEventType.UploadProgress || event.type === HttpEventType.Response) {
                                        waiting.delete(partNumber);
                                        loaded.set(partNumber, event.type === HttpEventType.Response ? part.size : Math.min(event.loaded, part.size));
                                        reportProgress();
                                    }
                                }),
                                filter((event : HttpEvent<string>) => event.type === HttpEventType.Response)
                            )).pipe(retryUpload(partNumber, true));
                        }, 2)
                    );
                })
            ).subscribe({
                error: (error : any) => subscriber.error(error),
                complete: () => {
                    confirming = true;
                    reportProgress();
                    //Si falla la confirmación, repetirla sin volver a transferir las partes
                    const confirmation = defer(() => completeUpload(uploadId)).pipe(
                        retryUpload(0)
                    ).subscribe({
                        next: (result : any) => {
                            if (result.message !== 'Success') {
                                subscriber.error(new Error('No se pudo confirmar el archivo'));
                                return;
                            }
                            finished = true;
                            subscriber.next({ progress: 100, confirming: false, complete: true, delayed: false });
                            subscriber.complete();
                        },
                        error: error => subscriber.error(error)
                    });
                    subscriber.add(confirmation);
                }
            });
            subscriber.add(task);
            return () => {
                if (uploadId && !finished) {
                    this.abortMultipartUpload(uploadId).subscribe({ error: () => {} });
                }
            };
        });
    }
//Fin de transferencia multipart reutilizable

    uploadOdtFile(form : FormData){
        return this.main.postRequestFormData(form, "/strategies/files/odt/");
    }

    updateSeenArtFile(strid : number){
        return this.main.postRequest ({ id_str : strid }, "/strategies/files/art/seen");
    }

    updateSeenOdtFile(strid : number){
        return this.main.postRequest({ id_str : strid }, "/strategies/files/odt/seen");
    }
//Distribution uploading area
    loadDist(campid: number){
        return this.main.getRequest( "/campaigns/distributions/" + campid);
    }

    validateUploadDist(form : FormData){
        return this.main.postRequestFormData(form, "/campaigns/files/distribution/validate");
    }

    uploadDist(form : FormData){
        return this.main.postRequestFormData(form, "/campaigns/files/distribution");
    }

    uploadDistTest(form : FormData){
        return this.main.postRequestFormData(form, "/campaigns/files/distribution_test");
    }

    getStrategyMaterialList(strID : number) {
        return this.main.getRequest("/strategies/odt/" + strID);
    }

    getIrregularities(campID : number) {
        return this.main.getRequest("/campaigns/irr/" + campID);
    }

    getCampaingList(){
        return this.main.getRequest("/campaigns/show-tracking-campaign-list").pipe(
          map((resp: any) => {
            let campaignList: Array<CampaignModel> = [];
            if(resp.message == "Success") {          
              resp.data.forEach((e:any) => {
                campaignList.push(e);
              });
            }     
            return campaignList;
          })
        );
    }

    getCampaignData(id:number){
        return this.main.getRequest(`/campaigns/get-campaign-tracking-info/${ id.toString() }`).pipe(
          map((resp: any) => {
            let campaignList: Array<CampaignTrackingModel> = [];
            if(resp.data.message == "Success") {          
              resp.data.data.forEach((e:any) => {
                campaignList.push(e);
              });
            }     
            return [campaignList, resp.data.tickets_extra];
          })
        );
    }

    updateTracking (id:string) {
        return this.main.getRequest(`/tracking/update-tracking/${ id }`);
      }


    searchCampaingFolio(search : string) {
        return this.main.getRequest("/campaigns/searchcampaingbyfolio/" + search.replace(/\//g, ""));
    }

    getPreviewArts(data : any, tipo:any){
        return this.main.postRequest({ data_files : data, tipo: tipo }, "/strategies/files/preview");
    }
}
